/**
 * Controller for the gallery direcitve to set the main image
 */
angular.module('impactx.displayelements').controller('SearchLevelsCtrl', ['$scope', 'OneTimeDataTransporter', SearchLevelsCtrl]);

function SearchLevelsCtrl($scope, OneTimeDataTransporter){
    this.moreTenders = function () {
        OneTimeDataTransporter.setAndRedirect($scope.tenders, $scope.trns, "search.tender.preset");
    };
    this.moreLots = function () {
        OneTimeDataTransporter.setAndRedirect($scope.lots, $scope.trns, "search.lot.preset");
    };
    this.moreVCats = function () {
        OneTimeDataTransporter.setAndRedirect($scope.vcats, $scope.trns, "search.catalog.preset");
    };
    this.moreSuppliers = function () {
        OneTimeDataTransporter.setAndRedirect($scope.suppliers, $scope.trns, "search.supplier.preset");
    };
}